export default __webpack_public_path__ + "1d240306062e714d7cc3b0c6ba313f6d.svg";